import { Box, Pagination } from "@mui/material";

// Shared pagination control for the patient/therapist listing pages —
// `pagination` is the { page, limit, total, totalPages } block the backend
// adds to these endpoints' responses.
function PortalPagination({ pagination, onChange }) {
  if (!pagination || pagination.totalPages <= 1) return null;
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
      <Pagination
        count={pagination.totalPages}
        page={pagination.page}
        onChange={(_, page) => onChange(page)}
        shape="rounded"
        color="primary"
      />
    </Box>
  );
}

export default PortalPagination;
